import type { SVGProps, FC } from "react"

const GroundMount: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="47.915"
    height="47.916"
    viewBox="0 0 47.915 47.916"
    fill="currentColor"
    {...props}
  >
    <g
      id="solar-panels_1_"
      data-name="solar-panels (1)"
      transform="translate(-7 -6.999)"
    >
      <path
        id="Path_717"
        data-name="Path 717"
        d="M47.958,48.917a.949.949,0,1,1,.68-.278A1.008,1.008,0,0,1,47.958,48.917Z"
        transform="translate(-1.668 -1.668)"
      />
      <path
        id="Path_718"
        data-name="Path 718"
        d="M53.875,48.917H51.958a.958.958,0,0,1,0-1.917h1.917a.958.958,0,0,1,0,1.917Z"
        transform="translate(-1.835 -1.668)"
      />
      <path
        id="Path_719"
        data-name="Path 719"
        d="M42.541,48.917H9.958a.958.958,0,1,1,0-1.917H42.541a.958.958,0,0,1,0,1.917Z"
        transform="translate(-0.083 -1.668)"
      />
      <path
        id="Path_720"
        data-name="Path 720"
        d="M47.527,20.917H14.973a.958.958,0,0,1,0-1.917H47.527a.958.958,0,0,1,0,1.917Z"
        transform="translate(-0.292 -0.5)"
      />
      <path
        id="Path_721"
        data-name="Path 721"
        d="M50.336,26.917H11.908a.958.958,0,0,1,0-1.917H50.336a.958.958,0,0,1,0,1.917Z"
        transform="translate(-0.165 -0.751)"
      />
      <path
        id="Path_722"
        data-name="Path 722"
        d="M51.716,32.917H10.4A.958.958,0,0,1,10.4,31H51.716a.958.958,0,0,1,0,1.917Z"
        transform="translate(-0.102 -1.001)"
      />
      <path
        id="Path_723"
        data-name="Path 723"
        d="M52.124,44.917H9.958a.958.958,0,1,1,0-1.917H52.124a.958.958,0,0,1,0,1.917Z"
        transform="translate(-0.083 -1.501)"
      />
      <path
        id="Path_724"
        data-name="Path 724"
        d="M53.094,38.917H8.9A.958.958,0,0,1,8.9,37h44.2a.958.958,0,0,1,0,1.917Z"
        transform="translate(-0.039 -1.251)"
      />
      <path
        id="Path_725"
        data-name="Path 725"
        d="M13.034,22.367a.976.976,0,0,1-.234-.029.958.958,0,0,1-.7-1.162A2.871,2.871,0,0,1,14.892,19a.958.958,0,0,1,0,1.917.957.957,0,0,0-.93.725.958.958,0,0,1-.929.725Z"
        transform="translate(-0.212 -0.5)"
      />
      <path
        id="Path_726"
        data-name="Path 726"
        d="M7.958,46.75A.959.959,0,0,1,7,45.792V41.958a.958.958,0,0,1,1.917,0v3.833A.959.959,0,0,1,7.958,46.75Z"
        transform="translate(0 -1.418)"
      />
      <path
        id="Path_727"
        data-name="Path 727"
        d="M9.875,44.813a2.893,2.893,0,0,1-2.789-3.574.958.958,0,1,1,1.859.466.977.977,0,0,0,.93,1.191.958.958,0,1,1,0,1.917Z"
        transform="translate(0 -1.397)"
      />
      <path
        id="Path_728"
        data-name="Path 728"
        d="M8.019,41.6a.976.976,0,0,1-.234-.029.958.958,0,0,1-.7-1.162l4.806-19.166a.958.958,0,1,1,1.859.466L8.948,40.871a.958.958,0,0,1-.929.725Z"
        transform="translate(-0.002 -0.563)"
      />
      <path
        id="Path_729"
        data-name="Path 729"
        d="M9.875,48.833A2.878,2.878,0,0,1,7,45.958a.958.958,0,1,1,1.917,0,.96.96,0,0,0,.958.958.958.958,0,1,1,0,1.917Z"
        transform="translate(0 -1.584)"
      />
      <path
        id="Path_730"
        data-name="Path 730"
        d="M50.8,22.367a.958.958,0,0,1-.929-.725.957.957,0,0,0-.93-.725.958.958,0,0,1,0-1.917,2.871,2.871,0,0,1,2.789,2.176.959.959,0,0,1-.7,1.162.974.974,0,0,1-.233.029Z"
        transform="translate(-1.709 -0.5)"
      />
      <path
        id="Path_731"
        data-name="Path 731"
        d="M55.958,46.75A.959.959,0,0,1,55,45.792V41.958a.958.958,0,0,1,1.917,0v3.833A.959.959,0,0,1,55.958,46.75Z"
        transform="translate(-2.001 -1.418)"
      />
      <path
        id="Path_732"
        data-name="Path 732"
        d="M53.958,44.813a.958.958,0,0,1,0-1.917.977.977,0,0,0,.929-1.191.958.958,0,0,1,1.858-.467,2.893,2.893,0,0,1-2.787,3.574Z"
        transform="translate(-1.918 -1.397)"
      />
      <path
        id="Path_733"
        data-name="Path 733"
        d="M55.687,41.6a.958.958,0,0,1-.929-.725L49.953,21.705a.958.958,0,1,1,1.859-.466l4.806,19.166a.958.958,0,0,1-.7,1.162A.976.976,0,0,1,55.687,41.6Z"
        transform="translate(-1.79 -0.564)"
      />
      <path
        id="Path_734"
        data-name="Path 734"
        d="M53.958,48.833a.958.958,0,1,1,0-1.917.96.96,0,0,0,.958-.958.958.958,0,1,1,1.917,0A2.878,2.878,0,0,1,53.958,48.833Z"
        transform="translate(-1.918 -1.584)"
      />
      <path
        id="Path_735"
        data-name="Path 735"
        d="M35.657,11.859a.96.96,0,0,1-.885-1.326l1.218-2.941a.959.959,0,1,1,1.771.734l-1.218,2.941A.962.962,0,0,1,35.657,11.859Z"
        transform="translate(-1.155 0)"
      />
      <path
        id="Path_736"
        data-name="Path 736"
        d="M40.889,17.165a.959.959,0,0,1-.367-1.845L43.463,14.1a.959.959,0,1,1,.734,1.771l-2.941,1.218A.958.958,0,0,1,40.889,17.165Z"
        transform="translate(-1.373 -0.293)"
      />
      <path
        id="Path_737"
        data-name="Path 737"
        d="M28.206,11.859a.958.958,0,0,1-.885-.592L26.1,8.325a.959.959,0,1,1,1.771-.734l1.218,2.941a.96.96,0,0,1-.885,1.326Z"
        transform="translate(-0.793)"
      />
      <path
        id="Path_738"
        data-name="Path 738"
        d="M22.9,17.165a.953.953,0,0,1-.366-.074l-2.941-1.218a.959.959,0,0,1,.734-1.771l2.941,1.218a.959.959,0,0,1-.368,1.845Z"
        transform="translate(-0.5 -0.293)"
      />
      <path
        id="Path_739"
        data-name="Path 739"
        d="M37.153,20.68a.959.959,0,0,1-.958-.958,4.472,4.472,0,1,0-8.945,0,.958.958,0,0,1-1.917,0,6.389,6.389,0,1,1,12.778,0A.959.959,0,0,1,37.153,20.68Z"
        transform="translate(-0.764 -0.264)"
      />
      <path
        id="Path_740"
        data-name="Path 740"
        d="M46.207,43.916a.957.957,0,0,1-.946-.816l-3.46-23a.958.958,0,0,1,1.9-.286l3.46,23a.958.958,0,0,1-.8,1.091A.928.928,0,0,1,46.207,43.916Z"
        transform="translate(-1.451 -0.5)"
      />
      <path
        id="Path_741"
        data-name="Path 741"
        d="M36.707,43.916a.959.959,0,0,1-.956-.91l-1.153-23a.958.958,0,0,1,1.914-.1l1.153,23a.958.958,0,0,1-.908,1.005.418.418,0,0,1-.049,0Z"
        transform="translate(-1.151 -0.5)"
      />
      <path
        id="Path_742"
        data-name="Path 742"
        d="M27.159,43.916H27.11A.957.957,0,0,1,26.2,42.91l1.154-23A.971.971,0,0,1,28.361,19a.957.957,0,0,1,.908,1.005l-1.154,23a.959.959,0,0,1-.956.909Z"
        transform="translate(-0.801 -0.5)"
      />
      <path
        id="Path_743"
        data-name="Path 743"
        d="M17.56,43.916a.906.906,0,0,1-.144-.011.958.958,0,0,1-.8-1.091l3.46-23a.958.958,0,0,1,1.9.286l-3.46,23A.96.96,0,0,1,17.56,43.916Z"
        transform="translate(-0.4 -0.5)"
      />
      <path
        id="Path_744"
        data-name="Path 744"
        d="M25.959,56.583a.907.907,0,0,1-.144-.011.958.958,0,0,1-.8-1.09l1.15-7.666a.958.958,0,0,1,1.895.285l-1.15,7.666A.957.957,0,0,1,25.959,56.583Z"
        transform="translate(-0.75 -1.668)"
      />
      <path
        id="Path_745"
        data-name="Path 745"
        d="M37.907,56.583a.958.958,0,0,1-.946-.816L35.812,48.1a.958.958,0,0,1,1.895-.285l1.15,7.666a.957.957,0,0,1-.8,1.09A.822.822,0,0,1,37.907,56.583Z"
        transform="translate(-1.201 -1.668)"
      />
      <path
        id="Path_746"
        data-name="Path 746"
        d="M41.124,56.917H21.958a.958.958,0,1,1,0-1.917H41.124a.958.958,0,0,1,0,1.917Z"
        transform="translate(-0.584 -2.001)"
      />
    </g>
  </svg>
)

export default GroundMount
